export const pagesAttendanceEngineEn = {
  atomDetail: {
    applyDialog: {
      cancel: 'Cancel',
      confirm: 'Apply',
      description:
        'Moves the record from draft to applied. The mock skips process-definition selection (production follows design §4.0).',
      title: 'Apply this master?',
    },
    applyError: 'Could not apply',
    applySuccess: 'Applied',
    deleteDialog: {
      blockedByUsage: 'In use by a work structure and cannot be deleted.',
      cancel: 'Cancel',
      confirm: 'Delete',
      description:
        'This cannot be undone. Remove it from work structure composition first if it is in use.',
      title: 'Delete this master?',
    },
    deleteError: 'Could not delete',
    deleteSuccess: 'Deleted',
    documentTitleFallback: 'Master detail',
    documentTitleSuffix: 'Attendance Engine',
    editDialog: {
      cancel: 'Cancel',
      save: 'Save',
      title: 'Edit master',
    },
    errors: {
      invalidConfigJson: 'Must be valid JSON',
    },
    fields: {
      countryCode: 'Country code',
      createdAt: 'Created at',
      createdBy: 'Created by',
      description: 'Description',
      isDefault: 'Legal default',
      lifecycleStatus: 'Status',
      name: 'Name',
      nameEn: 'English name',
      updatedAt: 'Updated at',
      validFrom: 'Valid from',
      validTo: 'Valid to (leave empty for open-ended)',
    },
    header: {
      apply: 'Apply',
      delete: 'Delete',
      edit: 'Edit',
      retire: 'Archive',
    },
    lifecycle: {
      applied: 'Active',
      archived: 'Archived',
      draft: 'Draft',
    },
    retireDialog: {
      cancel: 'Cancel',
      confirm: 'Archive',
      description:
        'Moves the record from applied to archived. Check downstream work structures if still referencing it.',
      title: 'Archive this master?',
    },
    retireError: 'Could not archive',
    retireSuccess: 'Archived',
    saveError: 'Could not save',
    saveSuccess: 'Saved',
    sections: {
      audit: 'Audit',
      basic: 'Basic information',
      logic: 'Logic',
      peopleCondition: 'People condition (People Group)',
      peopleConditionHint:
        'Optional peopleGroupIds live in config JSON. Edit them in the rule body above.',
      ruleBody: 'Rule body (config)',
      ruleBodyHint:
        'Stored as JSON. Omit peopleGroupIds or use an empty array when this component has no People Group scope (design §5.6).',
      usage: 'Where used',
    },
    usage: {
      attendanceStructures: 'Work structures',
      columns: {
        name: 'Name',
        type: 'Type',
      },
      empty: 'Not referenced by any work structure.',
    },
    view: {
      openEndedValidTo: '— (open-ended)',
    },
  },
  atomList: {
    addRecordLabels: {
      attendance_item: 'Add attendance item',
      attendance_logic_component: 'Add attendance logic component',
      attendance_unit: 'Add attendance unit',
      work_structure: 'Add work structure',
    },
    columns: {
      category: 'Category',
      country: 'Country',
      description: 'Description',
      name: 'Name',
      type: 'Type',
      validFrom: 'Valid From',
    },
    createRecordToastDescription:
      'Creating records from this list will be available when the create flow is implemented.',
    createRecordToastTitle: 'Not available yet',
    filters: {
      allCountries: 'All Countries',
      countryChip: 'Country',
      global: 'Global',
      jp: 'Japan',
    },
    lifecycleTabs: {
      all: 'All',
      applied: 'Active',
      archived: 'Archived',
      draft: 'Draft',
    },
  },
  attendanceStructures: {
    componentCount: '{{count}} components',
    custom: 'Custom',
    default: 'Default',
    noAttendanceStructures: 'No work structures registered',
    title: 'Work Structures',
  },
  attendanceStructuresList: {
    columns: {
      componentCount: 'Components',
      country: 'Country',
      description: 'Description',
      name: 'Name',
      nameEn: 'English name',
      type: 'Type',
      updatedAt: 'Updated',
    },
  },
  attendanceUnitsList: {
    columns: {
      countryCode: 'Country',
      description: 'Description',
      name: 'Name',
    },
    empty: 'No attendance units yet.',
  },
  categories: {
    agreement_36: 'Article 36 Agreement',
    attendance_manager: 'Attendance Manager',
    break_time: 'Break Time',
    late_night_work: 'Late Night Work',
    multi_month_80h: 'Multi-Month 80h',
    overtime: 'Overtime',
    overtime_45h_excess: '45h Excess',
    paid_leave: 'Paid Leave',
    shift_pattern: 'Shift Pattern',
    work_holiday_calendar: 'Work & Holiday Calendar',
    work_interval: 'Work Interval',
  },
  components: {
    columns: {
      category: 'Category',
      country: 'Country',
      description: 'Description',
      name: 'Name',
      type: 'Type',
      validFrom: 'Valid From',
    },
    filters: {
      allCategories: 'All Categories',
      allCountries: 'All Countries',
    },
    title: 'Components',
    types: {
      custom: 'Custom',
      default: 'Legal Default',
    },
  },
  itemsList: {
    columns: {
      badge: 'Badge',
      countryCode: 'Country',
      description: 'Description',
      name: 'Name',
    },
    empty: 'No attendance items yet.',
  },
  logicComponentsList: {
    columns: {
      badge: 'Badge',
      countryCode: 'Country',
      description: 'Description',
      name: 'Name',
    },
    empty: 'No attendance logic components yet.',
  },
  pageTitle: 'Attendance Engine',
  structureDetail: {
    composition: {
      empty: 'No engine components are linked.',
      missingRow: 'Component record not found.',
      openAtom: 'Open master detail',
      sameAsPaymentCycleNote: '',
      sectionTitle: 'Components in this structure',
    },
    deleteDialog: {
      cancel: 'Cancel',
      confirm: 'Delete',
      description:
        'This cannot be undone. Remove references from workforce assignments first if needed.',
      title: 'Delete this work structure?',
    },
    documentTitleFallback: 'Structure detail',
    documentTitleSuffix: 'Attendance Engine',
    editDialog: {
      cancel: 'Cancel',
      fields: {
        countryCode: 'Country code',
        description: 'Description',
        isDefault: 'Legal default',
        name: 'Name',
        nameEn: 'English name',
      },
      save: 'Save',
      saveError: 'Could not save',
      saveSuccess: 'Saved',
      title: 'Edit work structure',
    },
    fields: {
      countryCode: 'Country code',
      createdAt: 'Created at',
      createdBy: 'Created by',
      description: 'Description',
      isDefault: 'Legal default',
      lifecycleStatus: 'Status',
      name: 'Name',
      nameEn: 'English name',
      updatedAt: 'Updated at',
    },
    mock: {
      card: { detail: 'Detail' },
      empty: 'No attendance unit is selected.',
      loading: 'Loading…',
      openUnitDetail: 'Open unit detail page',
      section: {
        input: 'INPUT',
        output: 'OUTPUT',
        process: 'PROCESS',
      },
      sidebar: { close: 'Close side tab' },
      toolbar: {
        dryRun: 'Dry run:',
        run: 'Run',
        viewList: 'List',
        viewTree: 'Tree',
      },
    },
    sections: {
      audit: 'Audit',
      basic: 'Basic information',
      composition: 'Composition',
    },
  },
  tabs: {
    attendanceStructures: 'Attendance Structures',
    attendanceUnits: 'Attendance Units',
    items: 'Attendance Items',
    logicComponents: 'Logic Components',
  },
};
